import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () { return ({
    components: {
        MuiSelect: {
            styleOverrides: {
                icon: {
                    color: designTokens.color.gray.obsidian.value,
                    transform: 'rotate(90deg)',
                },
                iconOpen: {
                    color: designTokens.color.gray.obsidian.value,
                    transform: 'rotate(270deg)',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=selectTheme.js.map